import { useTranslation } from 'react-i18next'
import { CheckCircle, AlertTriangle, XCircle, HelpCircle } from 'lucide-react'

// Health is conveyed by ICON + TEXT, never colour alone (UX charter / WCAG).
const ITEMS = [
  { health: 'healthy', Icon: CheckCircle, className: 'text-green-600' },
  { health: 'degraded', Icon: AlertTriangle, className: 'text-amber-600' },
  { health: 'down', Icon: XCircle, className: 'text-red-600' },
  { health: 'unknown', Icon: HelpCircle, className: 'text-neutral-400' },
] as const

export function StatusLegend() {
  const { t } = useTranslation()
  return (
    <div className="flex items-center gap-4 text-xs text-neutral-500">
      {ITEMS.map(({ health, Icon, className }) => (
        <span key={health} className="flex items-center gap-1">
          <Icon size={14} className={className} aria-hidden />
          {t(`legend.${health}`)}
        </span>
      ))}
    </div>
  )
}
